import { Box, HStack, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import useGetLocationOptions from './queries/useGetLocationOptions';

/*
 * Lets a user jump directly to a different Location's edit page while
 * already inside one, without navigating back to the Locations list —
 * mirrors the old MultiChild breadcrumb/switcher dropdown.
 */
const LocationSwitcher = ({ darkMode, currentLocationId }) => {
    const navigate = useNavigate();
    const { data: locations = [], isLoading } = useGetLocationOptions();

    const handleSwitch = (item) => {
        if (item?.id && item.id !== currentLocationId) {
            navigate(`/regions-and-locations/locations/edit/${item.id}`);
        }
    };

    return (
        <HStack mb={4} spacing={3} alignItems="center">
            <Text fontWeight="600" whiteSpace="nowrap">
                All Locations &gt;
            </Text>
            <Box minW="260px">
                <DropDown
                    name="locationSwitcher"
                    data={locations}
                    shownValue="location"
                    currentId={currentLocationId}
                    selectedId="id"
                    isLoading={isLoading}
                    darkMode={darkMode}
                    noPadding
                    handleSelectChange={handleSwitch}
                />
            </Box>
        </HStack>
    );
};

export default LocationSwitcher;
